import React from 'react'
import PlayfairTable from './PlayfairTable'

const PlayfairCipherEncryption = ({ steps, shift, keyTable, result }) => {

    return (
        <div>
            <p style={{ textAlign: "left", fontSize: "20px", fontWeight: "bold", margin: "40px 0 10px 0" }}>Encryption</p>

            <div style={{ textAlign: "left", display: "flex" }}>
                <div style={{ display: "inline"}}>
                    <div className='wrapper'>
                    {steps.map((step) => (
                            <div key={Math.random()} style={{margin: 0}}>
                                <PlayfairTable selectedPlain={[step.value[0], step.value[1]]} selectedCipher={[step.value[2], step.value[3]]} keyTable={keyTable} ></PlayfairTable>
                            <div style={{ textAlign: "center"}}>
                                <p><span style={{ fontWeight: "bold" }}>Plain Text :</span>{step.value[0]}{step.value[1]}</p>
                                <p><span style={{ fontWeight: "bold"}}>Cipher Text :</span>{step.value[2]}{step.value[3]}</p>
                            </div>
                            </div>
                                
                    ))}
                    </div>
                </div>
                
            </div>
            <p style={{ fontSize: 19 }} ><span style={{ fontWeight: "bold" }}>Cipher Text :</span>{result}</p>
        </div>
    )
}

export default PlayfairCipherEncryption